var app = angular.module('tf.addAccount', [])

    .controller('newAccountCtrl', ['$scope', '$state', '$uibModal', '$http', '$filter', 'userConfig' , 'navSvc', function newAccountController($scope, $state, $uibModal, $http, $filter, userConfig, navSvc) {
        $scope.today = new Date();


        $scope.newAccountData = {
            accountName : userConfig.userInitial,
            brokerName : "",
            startingPositions : [],
            startingCash : null
        };

        $scope.newPosition = {
            q : null,
            c : null,
            p : null,
            t : null,
            isPickerOpen : false
        };

        $scope.addStartingPosition = function () {
            var newPosition = {
                q : $scope.newPosition.q,
                c : $scope.newPosition.c,
                p : $scope.newPosition.p,
                t : $scope.newPosition.t,
                isPickerOpen : $scope.newPosition.isPickerOpen
            };
            if (newPosition.t == null) {
                newPosition.t = $scope.today;
            }
            $scope.newAccountData.startingPositions.push($scope.newPosition);
            $scope.newPosition = {
                q : null,
                c : null,
                p : null,
                t : null,
                isPickerOpen : false
            };
            this.addPosition.$setPristine();
            this.addPosition.$setUntouched();
        };

        $scope.removeStartingPosition = function (position) {
            $scope.newAccountData.startingPositions = $scope.newAccountData.startingPositions.filter(function(p) {
                return p !== position;
            })
        };

        $scope.openDatePicker = function(position) {
            position.isPickerOpen = true;
        } ;

        $scope.dropzoneConfig = {
            'options': { // passed into the Dropzone constructor
                'url': '/tradefloor/api/upload/' + '0' + '/portfolio'
            },
            'eventHandlers': {
                'sending': function (file, formData, xhr) {
                },
                'success': function (file, response) {
                    $scope.showEdit = true;
                    $scope.showUpload = false;
                    if (response.length) {
                        for (var i = 0; i < response.length; i++) {
                            var position = response[i];

                            var exists = false;
                            for (var j = 0; j < $scope.newAccountData.startingPositions.length; j++) {
                                var startPosition = $scope.newAccountData.startingPositions[j];
                                if (startPosition.c == position.c && startPosition.p == position.p) {
                                    startPosition.q += position.q;
                                    exists = true;
                                }
                            }

                            if (!exists) {
                                var newStartPosition = {
                                    c: position.c,
                                    q: position.q,
                                    p : position.p,
                                    t : position.t

                                };
                                $scope.newAccountData.startingPositions.push(newStartPosition);
                            }
                        }
                    }
                    $scope.$digest();
                }
                ,
                'dragstart': function() {
                    $scope.showUploader();
                }
            }
        };

        $scope.submit = function () {
            var isoDateFilter = $filter('date');

            var submitData = {
                brokerName : $scope.newAccountData.brokerName,
                accountName : $scope.newAccountData.accountName,
                startingCash: $scope.newAccountData.startingCash,
                startingPositions : $scope.newAccountData.startingPositions.map(function(p) {
                    return {
                        q : p.q,
                        c : p.c,
                        p : p.p || 0,
                        t : p.t != null ? isoDateFilter(new Date(p.t), 'yyyy-MM-dd') : null
                    }})
            };

            return $http.put('/tradefloor/api/user/account', submitData).then(function(response) {
                var portfolio = response.data;
                navSvc.openPortfolio({
                    id : portfolio.id,
                    accountName : portfolio.accountName,
                    favourite : true
                });
                $state.go('portfolio', {portfolioId : portfolio.id});

            });
        };

        $scope.submitModelPortfolio = function () {
            var submitData = {
                accountName : $scope.newAccountData.accountName,
                startingCash: $scope.newAccountData.startingCash
            };

            return $http.put('/tradefloor/api/user/modelPortfolio', submitData).then(function(response) {
                var portfolio = response.data;
                navSvc.openPortfolio({
                    id : portfolio.id,
                    accountName : portfolio.accountName
                });
                $state.go('portfolio', {portfolioId : portfolio.id});

            });
        };


        $scope.cancel = function () {
            $state.go("client");
        };

        $scope.cancelModelPortfolio = function () {
            $state.go("adviser")
        };

    }]);
